import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import TimetableFormCalendar from '../svg/TimetableFormCalendar'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { ErrorMessage } from 'formik'
import { TextField } from '@mui/material'
import { useEffect, useState } from 'react'
import './fromTocalenderPicker.scss'
import { useDispatch } from 'react-redux'
import { setDateFrom, setDateTo } from '../../store/slice/inquiry/inquiry.slice'

const FromToCalenderPicker = ({ holder, onChange, className, label, width, placeholder, name, gap, showIcon = true, dateFrom, dateTo }) => {
    const dispatch = useDispatch()
    function customOnChange(dateObject) {
        const newDate = dateObject?.format('DD/MM/YYYY')
        onChange(newDate)
    }

    const [isOpen, setIsOpen] = useState(false)
    const [cleared, setCleared] = useState(false)

    useEffect(() => {
        if (cleared) {
            const timeout = setTimeout(() => {
                setCleared(false)
            }, 1500)
            if(dateFrom) dispatch(setDateFrom(undefined))
            if(dateTo) dispatch(setDateTo(undefined))
            
            return () => clearTimeout(timeout)
        }
        return () => { }
    }, [cleared])

    return (
        <div className='from-to-common-calendar-wrapper flex flex-column' style={{ width: width }}>
            {label && (
                <label className='from-to-common-calendar-input-label' htmlFor=''>
                    {label}
                </label>
            )}
            <div className='from-to-common-calendar-gap flex flex-column' style={{ gap: gap }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DatePicker']}>
                        <DatePicker
                            open={isOpen}
                            onClose={() => setIsOpen(false)}
                            slotProps={{
                                textField: {
                                    onClick: () => setIsOpen(true),
                                    placeholder:holder
                                },
                                field: { clearable: true, onClear: () => setCleared(true) },
                            }}
                            className={`from-to-common-calendar ${className}`}
                            // value={dayjs(value)}
                            onChange={customOnChange}
                            format='DD/MM/YYYY'
                            renderInput={(params) => <TextField {...params} placeholder={placeholder} />}
                            slots={{
                                openPickerIcon: showIcon ? TimetableFormCalendar : () => '',
                            }}
                        // disableOpenPicker
                        />
                    </DemoContainer>
                </LocalizationProvider>
                <ErrorMessage name={name} component='div' className='error-msg' />
            </div>
        </div>
    )
}

export default FromToCalenderPicker
